module.exports = new __parcel__URL__("snare_10.b2b762b9.mp3").toString();